import { observer } from 'mobx-react-lite'
import React, { type ReactNode, useState } from 'react'
import { Alert, Button } from 'shared/ui'
import styles from 'entities/Phone/ui/actions/assignInbox/ui/ui/styles.module.scss'
import { AssignNumberCommon } from 'entities/Phone'
import type { AssignInboxStore } from 'entities/Phone/ui/actions/assignInbox/ui'

type IAssignInboxDefaultProps = {
  assignInboxStore: AssignInboxStore
  additionalContent?: ReactNode
  mainContent?: ReactNode
  primaryButton?: ReactNode
  secondaryButton?: ReactNode
  disabledPrimary?: boolean
}

export const AssignInboxDefault = observer(
  ({
    assignInboxStore,
    additionalContent,
    mainContent,
    primaryButton,
    disabledPrimary,
    secondaryButton,
  }: IAssignInboxDefaultProps) => {
    const {
      idsLength,
      numbers,
      onAssignInboxModal,
      onAssignInboxModalClose,
      assignNumberCommonStore,
      disabledButton,
      loadingButton,
    } = assignInboxStore

    const [loading, setLoading] = useState(false)

    const handleAssignInboxModal = async () => {
      setLoading(true)
      await onAssignInboxModal()
      setLoading(false)
    }

    const desc =
      idsLength === 1
        ? `Assign ${numbers[0].formatted_number} number to an inbox`
        : `Assign ${idsLength} numbers to an inbox`

    return (
      <div className={styles.modalContent}>
        <Alert
          item={{
            type: 'infoBlue',
            desc,
          }}
        />
        {mainContent || (
          <>
            <AssignNumberCommon store={assignNumberCommonStore} />
            {additionalContent}
          </>
        )}

        <div className={styles.actions}>
          {secondaryButton || (
            <Button
              typeBtn={'contained'}
              text={'Cancel'}
              size={'medium'}
              contained={'secondary'}
              textClassname={styles.button}
              onClick={onAssignInboxModalClose}
            />
          )}
          {primaryButton || (
            <Button
              disabled={disabledButton || disabledPrimary}
              typeBtn={'contained'}
              text={`Assign ${idsLength} number${idsLength > 1 ? 's' : ''}`}
              size={'medium'}
              textClassname={styles.button}
              onClick={handleAssignInboxModal}
              loading={loadingButton || loading}
            />
          )}
        </div>
      </div>
    )
  }
)
